import { SagaIterator } from 'redux-saga';
import { all, takeLatest, select, call, put } from 'redux-saga/effects';
import { MCAFirebaseSaga } from '../root-saga';
import { setLoading, setError } from '../app-globals/actions';
import { setCustomer, saveCardCustomer } from './actions';
import { firestore } from '../../constants/firebase';
import { FirestoreSnapshot } from '../meals/types';
import {
  SaveCustomerAction,
  SAVE_CUSTOMER,
  SetCustomerDataAction,
  CustomerData,
  SET_CUSTOMER,
  GET_CUSTOMER,
  CREATE_CUSTOMER,
  CustomerCard,
  CreateStipeCustomer,
} from './types';
import { getUserState } from '../user/selector';

function* saveCustomer({ customers }: SaveCustomerAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Saving Customer info'));
    const { user } = yield select(getUserState);
    const body = {
      user: user.userid,
      usertype: user.accountType,
      customers,
    };
    const save = yield call(
      MCAFirebaseSaga.firestore.addDocument,
      'customers',
      body
    );
    yield put(setLoading(false, ''));
    console.log('save', save);
  } catch (error) {
    console.log('error', error);
    yield put(setLoading(false, ''));
  }
}

function* fetchCustomer(): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Set Customer info into redux'));
    const { user } = yield select(getUserState);
    const customerRef = firestore
      .collection('customers')
      .where('user', '==', user.userid);

    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      customerRef
    );

    const customers: CustomerData[] = [];

    snapshot.forEach((item: FirestoreSnapshot) => {
      const body = {
        id: item.id,
        ...item.data(),
      };
      customers.push(body);
    });
    yield put(setLoading(false, ''));
    yield put(setCustomer(customers));
  } catch (error) {
    console.log('error', error);
    yield put(setLoading(false, ''));
  }
}

function* createCardCustomer({
  customerCard,
}: CreateStipeCustomer): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Creating Customer'));
    const { user } = yield select(getUserState);
    const body = {
      ...customerCard,
      user: user.userid,
      usertype: user.accountType,
    };
    const card = yield call(
      MCAFirebaseSaga.functions.call,
      'createStripeCustomer',
      body,
      { method: 'POST' }
    );
    console.log('res', card);
    const cusbody = {
      cid: card.id,
      email: card.email,
      source: card.default_source,
      card: card.token.card,
    };
    yield put(saveCardCustomer(cusbody));
    yield put(setLoading(false, ''));
  } catch (error) {
    console.log('error', error);
    yield put(setLoading(false, ''));
    yield put(setError(true, error.message));
  }
}

export function* paymentCustomerSaga() {
  yield all([
    takeLatest(SAVE_CUSTOMER, saveCustomer),
    takeLatest(GET_CUSTOMER, fetchCustomer),
    takeLatest(CREATE_CUSTOMER, createCardCustomer),
  ]);
}
